import React from 'react';
import DataGrid, { Column, Pager, Paging, Export } from 'devextreme-react/data-grid';
import './list.css';

const List = ({ clients }) => {
  return (
    <div className="client-list">
      <DataGrid dataSource={clients} showBorders>
        <Export enabled fileName="clientes" />
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector allowedPageSizes={[5, 10, 20]} showInfo />
        <Column dataField="name" />
        <Column dataField="email" />
        <Column dataField="phone" />
      </DataGrid>
    </div>
  );
};

export default List;
